
import img1 from '../images/svg/icon-1.svg'
import img2 from '../images/svg/icon-2.svg'
import img3 from '../images/svg/icon-3.svg'
import img4 from '../images/svg/icon-4.svg'

const dataTeam = [

    {
        id: 1,
        img: img1,
        name: 'Full-Stack Development',
        position: 'React · Next.js · Node.js · TypeScript',
        desc: 'End-to-end web application development — from responsive frontends to scalable REST APIs and server-side logic.',
    },
    {
        id: 2,
        img: img2,
        name: 'UI/UX & Design Systems',
        position: 'Figma · SCSS · Tailwind · Component Libraries',
        desc: 'Crafting pixel-perfect interfaces with consistent design systems, smooth animations, and intuitive user flows.',
    },
    {
        id: 3,
        img: img3,
        name: 'Performance Optimisation',
        position: 'Core Web Vitals · Lazy Loading · Caching',
        desc: 'Diagnosing and resolving bottlenecks in data-heavy dashboards and large-scale apps for sub-second render times.',
    },
    {
        id: 4,
        img: img4,
        name: 'API & Backend Engineering',
        position: 'Node.js · Express · PostgreSQL · MongoDB',
        desc: 'Designing and building reliable, well-documented APIs with authentication, role-based access, and real-time capabilities.',
    },

]

export default dataTeam;
